import { Config } from './type';

const getConfig = (): Config => {
    const isServer = typeof window === 'undefined';
    
    let apiUrl = process.env.NEXT_PUBLIC_API_URL ?? '';
    
    if (isServer && process.env.INTERNAL_API_URL) {
        apiUrl = process.env.INTERNAL_API_URL;
    }

    return {
        GATEWAY_API_URL: apiUrl,
        ENVIRONMENT: (process.env.NEXT_PUBLIC_ENVIRONMENT as 'local' | 'dev' | 'prod') ?? 'local',
        GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? '',
        FACEBOOK_CLIENT_ID: process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID ?? '',
        GITHUB_CLIENT_ID: process.env.NEXT_PUBLIC_GITHUB_CLIENT_ID ?? '',
        TWITTER_CLIENT_ID: process.env.NEXT_PUBLIC_TWITTER_CLIENT_ID ?? '',
        TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? '',
    };
};

export const config = getConfig();
